module.exports = __webpack_public_path__ + "img/slide3.d06ed091.jpg";